import React, { useState } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false)
  const [privacyModalOpen1, setPrivacyModalOpen1] = useState(false)
    const [isYearly, setIsYearly] = useState(false)
  return (
    <div className="home-container1">
      <Helmet>
        <title>Idensite</title>
        <meta property="og:title" content="idensite" />
        <link
          rel="canonical"
          href="https://quizzical-fixed-beaver-a4asmg.teleporthq.site/"
        />
        <meta
          property="og:url"
          content="https://quizzical-fixed-beaver-a4asmg.teleporthq.site/"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section">
        <div className="hero-video-wrapper">
          <video
            src="https://videos.pexels.com/video-files/4957773/4957773-hd_1280_720_50fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/4957773/pictures/preview-0.jpg"
            autoPlay="true"
            playsInline="true"
            className="hero-bg-video"
          ></video>
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content-container">
          <div className="hero-text-block">
            <h1 className="home-hero-title hero-title">
              Websites voor vakmannen. Duidelijk, professioneel en snel.
            </h1>
            <p className="hero-subtitle home-hero-subtitle">
              Idensite ontwerpt en bouwt websites die duidelijk tonen wat je
              doet — met een nette oplevering en heldere afspraken.
            </p>
            <div className="hero-actions">
              <a href="mailto:contact@idensite.be?subject=">
                <div className="btn-lg btn-primary btn">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                    <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                  </svg>
                  <span>
                    {' '}
                    Contact via e-mail
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </div>
              </a>
              <a href="#prijzen">
                <div className="btn-lg hero-btn-outline btn btn-outline">
                  <span>Bekijk prijzen</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<script>
(function(){
  // Privacy Modal Functionality
  ;(function () {
    const privacyModal = document.querySelector('[data-modal="privacy"]')
    const openTriggers = document.querySelectorAll('[data-action="open-privacy-modal"]')
    const closeTriggers = document.querySelectorAll('[data-action="close-privacy-modal"]')

    let privacyModalOpen = false

    function openModal(e) {
      if (e) e.preventDefault()
      privacyModalOpen = true
      privacyModal.setAttribute("data-state", "open")
      document.body.style.overflow = "hidden"

      // Focus trap - focus on close button for accessibility
      const closeButton = privacyModal.querySelector(".privacy-modal-close")
      if (closeButton) closeButton.focus()
    }

    function closeModal() {
      privacyModalOpen = false
      privacyModal.setAttribute("data-state", "closed")
      document.body.style.overflow = ""
    }

    // Open modal on Privacy Policy link click
    openTriggers.forEach((trigger) => {
      trigger.addEventListener("click", openModal)
    })

    // Close modal on close button or backdrop click
    closeTriggers.forEach((trigger) => {
      trigger.addEventListener("click", closeModal)
    })

    // Close on Escape key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && privacyModalOpen) {
        closeModal()
      }
    })

    // Prevent closing when clicking inside the modal card
    const modalCard = privacyModal.querySelector(".privacy-modal-card")
    if (modalCard) {
      modalCard.addEventListener("click", function (e) {
        e.stopPropagation()
      })
    }
  })()
})()
</script>`}
          ></Script>
        </div>
      </div>
      <section className="intro-section">
        <div className="intro-container">
          <div className="intro-card">
            <div className="intro-header">
              <h2 className="section-title">Wie is Idensite</h2>
              <p className="section-content">
                Idensite is een Belgisch webdesign &amp; development bureau
                gespecialiseerd in websites voor vakmannen. Wij combineren
                technische expertise met een no-nonsense aanpak voor een
                resultaat dat werkt.
              </p>
            </div>
            <div className="intro-values">
              <div className="value-item">
                <div className="value-icon">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </div>
                <span className="section-content">Snel &amp; Efficiënt</span>
              </div>
              <div className="value-item">
                <div className="value-icon">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </div>
                <span className="section-content">Professioneel Design</span>
              </div>
              <div className="value-item">
                <div className="value-icon">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </div>
                <span className="section-content">Heldere Afspraken</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="proces" className="process-section">
        <div className="home-process-container">
          <h2 className="text-center section-title">Ons Werkproces</h2>
          <div className="home-process-stepper">
            <div className="home-step-item">
              <div className="home-step-number">
                <span>1</span>
              </div>
              <h3 className="section-subtitle">Intake</h3>
              <p className="section-content">
                E-mail of telefonisch gesprek om uw wensen en doelen in kaart te
                brengen.
              </p>
            </div>
            <div className="step-divider"></div>
            <div className="home-step-item">
              <div className="home-step-number">
                <span>2</span>
              </div>
              <h3 className="section-subtitle">Design + bouw</h3>
              <p className="section-content">
                Wij vertalen uw vakmanschap naar een modern digitaal ontwerp en
                bouwen de site.
              </p>
            </div>
            <div className="step-divider"></div>
            <div className="home-step-item">
              <div className="home-step-number">
                <span>3</span>
              </div>
              <h3 className="section-subtitle">Oplevering</h3>
              <p className="section-content">
                Uw website gaat live. Klaar om nieuwe klanten te verwelkomen.
              </p>
            </div>
          </div>
          <div className="process-payment-note">
            <div className="payment-badge">
              <svg
                fill="none"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                <path d="m9 12l2 2l4-4"></path>
              </svg>
              <span className="section-content">
                30% voorschot, 70% bij oplevering
              </span>
            </div>
          </div>
        </div>
      </section>
      {/*<section id="voorbeelden" className="portfolio-section">
        <div className="portfolio-grid">
          <div className="portfolio-card">
            <img
              alt="One-page website example"
              src="https://images.pexels.com/photos/34602781/pexels-photo-34602781.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="portfolio-img"
            />
            <div className="portfolio-overlay">
              <h3 className="section-subtitle">One-page website</h3>
              <p className="section-content">
                Perfect voor de startende vakman.
              </p>
            </div>
          </div>
          <div className="portfolio-card">
            <img
              alt="Multi-page website example"
              src="https://images.pexels.com/photos/34938432/pexels-photo-34938432.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="portfolio-img"
            />
            <div className="portfolio-overlay">
              <h3 className="section-subtitle">Multi-page website</h3>
              <p className="section-content">
                Uitgebreide presentatie van uw diensten.
              </p>
            </div>
          </div>
          <div className="portfolio-card">
            <img
              alt="Portfolio project example"
              src="https://images.pexels.com/photos/34602783/pexels-photo-34602783.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="portfolio-img"
            />
            <div className="portfolio-overlay">
              <h3 className="section-subtitle">Realisaties / Portfolio</h3>
              <p className="section-content">
                Toon uw projecten in een galerij.
              </p>
            </div>
          </div>
          <div aria-hidden="true" className="decorative-filler portfolio-card">
            <img
              alt="Decorative workshop"
              src="https://images.pexels.com/photos/30871012/pexels-photo-30871012.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="portfolio-img"
            />
          </div>
          <div aria-hidden="true" className="decorative-filler portfolio-card">
            <img
              alt="Decorative craftsman"
              src="https://images.pexels.com/photos/7484156/pexels-photo-7484156.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="portfolio-img"
            />
          </div>
          <div aria-hidden="true" className="decorative-filler portfolio-card">
            <img
              alt="Decorative tools"
              src="https://images.pexels.com/photos/7019392/pexels-photo-7019392.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="portfolio-img"
            />
          </div>
        </div>
      </section>*/}
        <section id="prijzen" className="pricing-section">
            <div className="pricing-container">
                <div className="pricing-main-card">

                    <div className="pricing-header">
                        <h2 className="section-title">Eenvoudige Prijsstructuur</h2>
                        <p className="section-content">Geen verborgen kosten. Duidelijke tarieven voor vakmannen.</p>
                    </div>

                    {/* Billing Toggle */}
                    <div className="billing-toggle-wrapper">
                        <span className={`billing-label${!isYearly ? ' active' : ''}`}>Maandelijks</span>
                        <label className="toggle-switch" aria-label="Schakel naar jaarlijkse betaling">
                            <input
                                type="checkbox"
                                checked={isYearly}
                                onChange={() => setIsYearly(!isYearly)}
                            />
                            <span className="toggle-track"></span>
                            <span className="toggle-thumb"></span>
                        </label>
                        <span className={`billing-label${isYearly ? ' active' : ''}`}>Jaarlijks</span>
                        {isYearly && <span className="yearly-badge">2 maanden gratis</span>}
                    </div>

                    {/* Één kaart met twee blokken */}
                    <div className="pricing-card-single">

                        {/* Blok 1: Eenmalige ontwikkeling */}
                        <div className="block-ontwikkeling">
                            <p className="block-label">Website op maat</p>
                            <div className="price-row-new">
                                <span className="price-currency-new">€</span>
                                <span className="price-amount-new">450</span>
                            </div>
                            <p className="price-subtitle-new">Eénmalige kost bij opstart</p>
                            <ul className="price-features">
                                <li className="section-content"><span>Website met max. 5 pagina&apos;s</span></li>
                                <li className="section-content"><span>Responsief ontwerp (desktop &amp; mobiel)</span></li>
                                <li className="section-content"><span>Basisstructuur voor zoekmachines (SEO)</span></li>
                                <li className="section-content"><span>Online publicatie inbegrepen</span></li>
                                <li className="section-content"><span>30% voorschot bij start • 70% bij oplevering</span></li>

                            </ul>
                        </div>

                        {/* Divider */}
                        <div className="card-divider-row">
                            <div className="divider-line"></div>
                            <span className="divider-label">+ maandelijks</span>
                            <div className="divider-line"></div>
                        </div>

                        {/* Blok 2: Maandelijkse dienstverlening */}
                        <div className="block-maandelijks">
                            <p className="block-label">Maandelijkse dienstverlening</p>
                            <div className="price-row-new">
                                <span className="monthly-currency-new">€</span>
                                <span className="monthly-amount-new">{isYearly ? 120 : 12}</span>
                                <span className="monthly-period-new">{isYearly ? '/jaar' : '/maand'}</span>
                            </div>
                            {isYearly
                                ? <p className="yearly-saving-note">Jaarlijks betalen = 2 maanden gratis</p>
                                : <p className="yearly-saving-note">&nbsp;</p>
                            }
                            <ul className="price-features">
                                <li className="section-content"><span>Hosting van de website</span></li>
                                <li className="section-content"><span>Technisch onderhoud, beveiliging &amp; back-ups</span></li>
                                <li className="section-content"><span>Domeinnaambeheer</span></li>
                                <li className="section-content"><span>1 kleine inhoudelijke wijziging per maand</span></li>
                            </ul>
                            <a href="mailto:contact@idensite.be?subject=Website%20Aanvraag">
                                <div className="btn-lg btn btn-accent">Start jouw project</div>
                            </a>
                        </div>
                    </div>

                    {/*<p className="pricing-footer-note">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                        </svg>
                        30% voorschot bij start &bull; 70% bij oplevering
                    </p>*/}

                </div>
            </div>
        </section>


        <section className="home-thq-testimonials-section-elm testimonials-section">
        <div className="testimonials-rail">
          <div className="testimonial-card">
            <div className="stars">
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
            </div>
            <p className="section-content">
              &quot;Eindelijk een website die echt toont wat ik doe zonder
              gedoe. Snel geregeld en professioneel.&quot;
            </p>
            <div className="testimonial-author">
              <span className="section-subtitle">Jan Peeters</span>
              <span className="section-content">Schrijnwerker</span>
            </div>
          </div>
          <div className="testimonial-card">
            <div className="stars">
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
            </div>
            <p className="section-content">
              &quot;Idensite begrijpt wat een zelfstandige nodig heeft. Geen
              blabla, gewoon een goeie site.&quot;
            </p>
            <div className="testimonial-author">
              <span className="section-subtitle">Marc Willems</span>
              <span className="section-content">Loodgieter</span>
            </div>
          </div>
          <div className="testimonial-card">
            <div className="stars">
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
              <svg
                fill="currentColor"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
              </svg>
            </div>
            <p className="section-content">
              &quot;Sinds de nieuwe website krijg ik veel meer aanvragen via
              e-mail. Een top investering.&quot;
            </p>
            <div className="testimonial-author">
              <span className="section-subtitle">Kevin Smets</span>
              <span className="section-content">Elektricien</span>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" className="contact-section">
        <div className="contact-container">
          <div className="contact-card">
            <div className="contact-info">
              <h2 className="section-title">Klaar voor een nieuwe website?</h2>
              <p className="section-content">
                Stuur ons een e-mail met uw noden en we nemen zo snel mogelijk
                contact met u op.
              </p>
              <div className="contact-details">
                <a href="mailto:contact@idensite.be?subject=">
                  <div className="home-contact-link">
                    <svg
                      fill="none"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                      <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                    </svg>
                    <span>
                      {' '}
                      contact@idensite.be
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                </a>
                <a href="tel:+32470111513">
                  <div className="home-contact-link">
                    <svg
                      fill="none"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"></path>
                    </svg>
                    <span>
                      {' '}
                      +32 (0) 470 11 15 13
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                </a>
              </div>
            </div>
            <div className="contact-form-wrapper">
              <form
                action="https://formspree.io/f/mjgjawwo"
                method="POST"
                data-form-id="1eac1c8d-1f09-4f32-99a1-edb4df0e0aa8"
                className="contact-form"
              >
                <div className="form-group">
                  <label htmlFor="name" className="section-content">
                    Naam
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="true"
                    required="true"
                    placeholder="Uw naam"
                    data-form-field-id="name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email" className="section-content">
                    E-mail
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required="true"
                    placeholder="Voer uw e-mail in"
                    data-form-field-id="email"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message" className="section-content">
                    Bericht
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required="true"
                    placeholder="Hoe kunnen we u helpen?"
                    data-form-field-id="message"
                  ></textarea>
                </div>
                <div className="form-consent">
                  <input
                    type="checkbox"
                    id="consent"
                    name="consent"
                    required="true"
                    data-form-field-id="consent"
                  />
                  <label htmlFor="consent" className="section-content">
                    Ik ga akkoord met de verwerking van mijn gegevens.
                  </label>
                </div>
                <button
                  id="thq_button_TgY7"
                  name="button"
                  type="submit"
                  data-form-field-id="thq_button_TgY7"
                  className="btn-lg btn-primary btn"
                >
                  Verstuur aanvraag
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container4">
        <div className="home-container5">
          <Script
            html={`<style>
section {
  padding: var(--spacing-4xl) 0;
  position: relative;
  overflow: hidden;
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="home-container6">
        <div className="home-container7">
          <Script
            html={`<script defer data-name="idensite-interactions">
(function(){
  // Intersection Observer for scroll animations
  const observerOptions = {
    threshold: 0.1,
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
        observer.unobserve(entry.target)
      }
    })
  }, observerOptions)

  // Select elements to animate
  const animateElements = document.querySelectorAll(".intro-card, .step-item, .price-box, .contact-card")

  animateElements.forEach((el) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(30px)"
    el.style.transition = "all 0.6s ease-out"
    observer.observe(el)
  })

  // Staggered animation for values
  const valueItems = document.querySelectorAll(".value-item")
  valueItems.forEach((item, index) => {
    item.style.opacity = "0"
    item.style.transform = "translateX(-20px)"
    item.style.transition = \`all 0.5s ease-out \${index * 0.1}s\`

    const valueObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = "1"
            entry.target.style.transform = "translateX(0)"
          }
        })
      },
      { threshold: 0.5 }
    )

    valueObserver.observe(item)
  })

  // Handle form submission visual feedback
  const contactForm = document.querySelector(".contact-form")
  if (contactForm) {
    contactForm.addEventListener("submit", (e) => {
      // Native submission happens unless we prevent it,
      // but we can add visual feedback before it reloads/submits
      const submitBtn = contactForm.querySelector('button[type="submit"]')
      submitBtn.textContent = "Verzenden..."
      submitBtn.style.opacity = "0.7"
      submitBtn.disabled = true
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
      <div
        data-modal="privacy"
        data-state="closed"
        className="privacy-modal-overlay"
      >
        <div
          data-action="close-privacy-modal"
          className="home-thq-privacy-modal-backdrop-elm"
        ></div>
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="privacy-modal-title"
          className="privacy-modal-card"
        >
          <div className="home-thq-privacy-modal-header-elm">
            <h2
              id="privacy-modal-title"
              className="home-thq-privacy-modal-title-elm"
            >
              Privacy Policy
            </h2>
            <button
              type="button"
              data-action="close-privacy-modal"
              aria-label="Sluiten"
              className="button privacy-modal-close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div className="home-thq-privacy-modal-content-elm">
            <div className="privacy-modal-section">
              <h3>1. Dataverzameling</h3>
              <p>
                Idensite verzamelt alleen persoonsgegevens die u vrijwillig aan
                ons verstrekt via het contactformulier op deze website. Deze
                gegevens omvatten:
              </p>
              <ul className="list">
                <li className="list-item">
                  <span>Naam en voornaam</span>
                </li>
                <li className="list-item">
                  <span>E-mailadres</span>
                </li>
                <li className="list-item">
                  <span>Telefoonnummer (optioneel)</span>
                </li>
                <li className="list-item">
                  <span>Berichtinhoud</span>
                </li>
              </ul>
              <p>
                We verzamelen geen gegevens zonder uw expliciete toestemming.
              </p>
            </div>
            <div className="privacy-modal-section">
              <h3>2. Cookies</h3>
              <p>
                Onze website maakt gebruik van essentiële cookies die
                noodzakelijk zijn voor de technische werking van de site. We
                gebruiken geen tracking cookies of third-party analytics zonder
                uw toestemming.
              </p>
              <p>De cookies die we gebruiken zijn:</p>
              <ul className="list">
                <li className="list-item">
                  <span>Sessiecookies voor het behouden van formulierdata</span>
                </li>
                <li className="list-item">
                  <span>Technische cookies voor websitefunctionaliteit</span>
                </li>
              </ul>
            </div>
            <div className="privacy-modal-section">
              <h3>3. Contactinformatie Opslag</h3>
              <p>
                Wanneer u een contactaanvraag indient, slaan we uw gegevens op
                in ons klantensysteem. Deze informatie wordt gebruikt om:
              </p>
              <ul className="list">
                <li className="list-item">
                  <span>Uw aanvraag te beantwoorden</span>
                </li>
                <li className="list-item">
                  <span>Onze diensten te leveren</span>
                </li>
                <li className="list-item">
                  <span>Communicatie over uw project te onderhouden</span>
                </li>
              </ul>
            </div>
            <div className="privacy-modal-section">
              <h3>4. Rechtsgrondslag</h3>
              <p>De verwerking van uw persoonsgegevens gebeurt op basis van:</p>
              <ul className="list">
                <li className="list-item">
                  <strong>Toestemming:</strong>
                  <span>
                    {' '}
                    Wanneer u het contactformulier invult
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </li>
                <li className="list-item">
                  <strong>Uitvoering van overeenkomst:</strong>
                  <span>
                    {' '}
                    Voor projecten die we voor u uitvoeren
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </li>
                <li className="list-item">
                  <strong>Gerechtvaardigd belang:</strong>
                  <span>
                    {' '}
                    Voor het verbeteren van onze diensten
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </li>
              </ul>
              <p>
                We voldoen aan de Algemene Verordening Gegevensbescherming
                (AVG/GDPR).
              </p>
            </div>
            <div className="privacy-modal-section">
              <h3>5. Bewaartermijn</h3>
              <p>
                We bewaren uw persoonsgegevens niet langer dan noodzakelijk:
              </p>
              <ul className="list">
                <li className="list-item">
                  <span>Contactaanvragen: 2 jaar na laatste contact</span>
                </li>
                <li className="list-item">
                  <span>
                    Klantgegevens: 7 jaar (wettelijke boekhoudverplichting)
                  </span>
                </li>
                <li className="list-item">
                  <span>
                    Projectgerelateerde data: 5 jaar na projectafronding
                  </span>
                </li>
              </ul>
              <p>
                Na deze termijn worden uw gegevens veilig verwijderd of
                geanonimiseerd.
              </p>
            </div>
            <div className="privacy-modal-section">
              <h3>6. Uw Rechten</h3>
              <p>Als betrokkene heeft u de volgende rechten onder de AVG:</p>
              <ul className="list">
                <li className="list-item">
                  <strong>Recht op inzage:</strong>
                  <span>
                    {' '}
                    U kunt vragen welke gegevens we van u bewaren
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </li>
                <li className="list-item">
                  <strong>Recht op rectificatie:</strong>
                  <span>
                    {' '}
                    U kunt onjuiste gegevens laten corrigeren
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </li>
                <li className="list-item">
                  <strong>Recht op verwijdering:</strong>
                  <span>
                    {' '}
                    U kunt vragen om verwijdering van uw gegevens (&quot;recht
                    om vergeten te worden&quot;)
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </li>
                <li className="list-item">
                  <strong>Recht op beperking:</strong>
                  <span>
                    {' '}
                    U kunt de verwerking van uw gegevens laten beperken
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </li>
                <li className="list-item">
                  <strong>Recht op overdraagbaarheid:</strong>
                  <span>
                    {' '}
                    U kunt uw gegevens in een gestructureerd formaat ontvangen
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </li>
                <li className="list-item">
                  <strong>Recht van bezwaar:</strong>
                  <span>
                    {' '}
                    U kunt bezwaar maken tegen verwerking op basis van
                    gerechtvaardigd belang
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="home-thq-privacy-modal-footer-elm">
            <button
              type="button"
              data-action="close-privacy-modal"
              className="btn btn-primary button"
            >
              Sluiten
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
